import { useRouteSection } from '@/hooks/useRouteSection';
import { useTranslation } from 'react-i18next';

export const CovidAddonContent = () => {
  const routeSection = useRouteSection();
  const { t } = useTranslation('translation', {
    keyPrefix: 'covid',
  });

  return {
    gaTitle: t('gaTitle'),
    default: {
      title: t('title'),
      label: t('label'),
      remark: t('remark', { age: 70 }),
      amount: '',
      amountRemark: '',
      coverages: [
        {
          label: t('label.cancellation'),
          description: t('upTo', { amount: 'RM5,000' }),
          remark: t('maximum', { amount: 'RM12,500' }),
        },
        {
          label: t('label.disruption'),
          description: t('upTo', { amount: 'RM5,000' }),
          remark: t('maximum', { amount: 'RM12,500' }),
        },
        {
          label: t('label.medical'),
          description: t('upTo', { amount: 'RM300,000' }),
          remark: t('maximum', { amount: 'RM750,000' }),
        },
        {
          label: t('label.emergency'),
          description: t('upTo', { amount: 'RM100,000' }),
          remark: t('maximum', { amount: 'RM250,000' }),
        },
        {
          label: t('label.repatriation'),
          description: t('upTo', { amount: 'RM100,000' }),
          remark: t('maximum', { amount: 'RM250,000' }),
        },
      ],
      noteLabel: t('label.note'),
      notes: [
        t('note.limit', { minAge: 61, maxAge: 70 }),
        t('note.maximum'),
        t(`note.link.${routeSection}`),
      ],
    },
    senior: {
      title: t('title'),
      label: t('label'),
      remark: '',
      amount: '',
      amountRemark: '',
      coverages: [
        {
          label: t('label.medical'),
          description: t('upTo', { amount: 'RM150,000' }),
          remark: t('ageBetween.senior', { minAge: 71, maxAge: 80 }),
        },
        {
          label: t('label.emergency'),
          description: t('upTo', { amount: 'RM50,000' }),
          remark: t('ageBetween.senior', { minAge: 71, maxAge: 80 }),
        },
        {
          label: t('label.repatriation'),
          description: t('upTo', { amount: 'RM50,000' }),
          remark: t('ageBetween.senior', { minAge: 71, maxAge: 80 }),
        },
      ],
      noteLabel: t('label.note'),
      notes: [
        t('note.limit', { minAge: 61, maxAge: 80 }),
        t(`note.link.${routeSection}`),
      ],
    },
    family: {
      title: t('title'),
      label: t('label'),
      remark: t('remark', { age: 80 }),
      amount: '',
      amountRemark: '',
      coverages: [
        {
          label: t('label.cancellation'),
          description: t('upTo', { amount: 'RM12,500' }),
          remark: '',
        },
        {
          label: t('label.disruption'),
          description: t('upTo', { amount: 'RM12,500' }),
          remark: '',
        },
        {
          label: t('label.medical'),
          description: t('upTo', { amount: 'RM750,000' }),
          remark: '',
        },
        {
          label: t('label.emergency'),
          description: t('upTo', { amount: 'RM250,000' }),
          remark: '',
        },
        {
          label: t('label.repatriation'),
          description: t('upTo', { amount: 'RM250,000' }),
          remark: '',
        },
      ],
      noteLabel: t('label.note'),
      notes: [
        t('note.limit', { minAge: 61, maxAge: 70 }),
        t('note.maximum'),
        t(`note.link.${routeSection}`),
      ],
    },
  };
};

export default CovidAddonContent;
